import React from "react";
import { Switch, Route } from "react-router-dom";
import ROUTES from "../../../../AppRouter/routes";
import TrapSiteTable from "./TrapSiteTable";
import TrapSiteEdit from "./TrapSiteEdit";
import TrapSiteCreate from "./TrapSiteCreate";
import { SitesTabs } from "./SitesTabs";
import { SiteGroups } from "../SiteGroups/SiteGroups";
import { newReportsEnabled } from "../../../../../utils/features";

const Index = () => {
  if (!newReportsEnabled()) {
    return (
      <Switch>
        <Route path={ROUTES.editTrapSite} component={TrapSiteEdit} />
        <Route path={ROUTES.createTrapSite} component={TrapSiteCreate} />
        <Route path={ROUTES.trapSite} component={TrapSiteTable} />
      </Switch>
    );
  }

  return (
    <Switch>
      <Route path={ROUTES.editTrapSite} component={TrapSiteEdit} />
      <Route path={ROUTES.createTrapSite} component={TrapSiteCreate} />
      <Route path={ROUTES.siteGroups}>
        <SitesTabs />
        <SiteGroups />
      </Route>
      <Route path={ROUTES.trapSite}>
        <SitesTabs />
        <TrapSiteTable />
      </Route>
    </Switch>
  );
};

export default Index;
